import React from 'react';
import './ButtonPlus.css';
import PropTypes from 'prop-types';
import ButtonSquare from './BasicButton';
import plusIcon from './assets/img/cross_button_icon.png';
import plusIconDark from './assets/img/cross_button_icon_dark.png';

const ButtonPlus = (props) => {
  const { theme, link } = props;
  let buttonStyle = {
    width: '50px',
    height: '50px',
  };
  if (theme === 'dark') {
    buttonStyle.background = `url(${plusIconDark}) no-repeat center`;
  } else {
    buttonStyle.background = `url(${plusIcon}) no-repeat center`;
  }
  return (
    <ButtonSquare link={link}>
      <div style={buttonStyle} className="animate-plus" />
    </ButtonSquare>


  );
};

ButtonPlus.defaultProps = {
  theme: 'light',
  link: '/',
};

ButtonPlus.propTypes = {
  theme: PropTypes.string,
  link: PropTypes.string,
};

export default ButtonPlus;



// WEBPACK FOOTER //
// ./src/components/ButtonSquare/ButtonPlus.jsx